module.exports = __webpack_public_path__ + "img/logo_usach.fe22b35e.png";